import SpoilerViewerWrapper from "./Components/Wrappers/SpoilerViewerWrapper.js";
import { SPOILER_TYPE } from "./types.js";
import { initSpoilersContentState } from "./utils/spoilerUtilsFn.js";
import nodeViewDecorator from "./nodeViewDecorator.js";
const pluginSpoiler = (config) => {
  return {
    config: { initSpoilersContentState, SpoilerViewerWrapper, ...config },
    type: SPOILER_TYPE,
    nodeViewDecorators: [nodeViewDecorator]
  };
};
export {
  SpoilerViewerWrapper,
  initSpoilersContentState,
  pluginSpoiler
};
//# sourceMappingURL=viewer.js.map
